import { useCallback, useEffect, useState } from 'react';
import { getPreferences } from '@/services/preferencesService';

export function useUserRoles() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isReviewer, setIsReviewer] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const prefs = await getPreferences();
      setIsAdmin(prefs.is_admin === true);
      setIsReviewer(prefs.is_reviewer === true);
    } catch {
      setIsAdmin(false);
      setIsReviewer(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    isAdmin,
    isReviewer,
    isReviewerOnly: isReviewer && !isAdmin,
    loading,
    refresh,
  };
}

export async function homePathForCurrentUser(): Promise<string> {
  try {
    const prefs = await getPreferences();
    if (prefs.is_reviewer === true && prefs.is_admin !== true) {
      return '/reviewer';
    }
  } catch {
    /* fall through */
  }
  return '/home';
}
